module.exports = __webpack_public_path__ + "static/media/smartphone_man_stand.624bc487.png";